import Component, { UserManagementTextLink } from './component'

export { UserManagementTextLink }

export default Component
